import {createSelector} from 'reselect';

import firstBy from 'thenby';

import {NAME} from './constants';

export const getUserName = state => state[NAME].credentials.userName;
export const getFullName = state => state[NAME].credentials.fullName;
export const isAttemptingLogin = state => state[NAME].attemptingLogin;
export const isDemoModalOpen = state => state[NAME].showDemoModal;
export const isContextLoaded = state => state[NAME].contextLoaded;
export const isMasterUser = state => state[NAME].credentials.isMasterUser;
export const isDemoUser = state => state[NAME].credentials.isDemoUser;

export const getSubscriptions = state => state[NAME].subscriptions.sort(firstBy(function (v1) { return v1.id === state[NAME].activeSubscriptionId?0:10; }).thenBy("name"));
export const getActiveSubscriptionId = state => state[NAME].activeSubscriptionId;
export const hasMultipleSubscriptions = state => (state[NAME].subscriptions.length > 1) ? true : false;

export const getManagementLink = state => state[NAME].managementLink;

export const getActiveSubscription = createSelector(
	getSubscriptions,
	getActiveSubscriptionId,
	(subscriptionList, activeSubscription) => {
		return subscriptionList.find((subscription) => {
			return subscription.id === activeSubscription;
		});
	} 
);

export const getActiveSubscriptionName = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.name : '';
	}
);

export const getActivePermissions = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.permissions : [];
	}
);

export const isCareSheetsSupported = createSelector(
	getActiveSubscription,
	(activeSubscription) => {

		if(activeSubscription !== undefined)
			{
				return activeSubscription.supportsCareSheets;
			}

		return false;
	}
);

export const getActiveExcelKey = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.excelKey : 0;
	}
);

export const getActiveStyles = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.styles : {};
	}
);

export const getActiveLogos = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.logos : {};
	}
);

export const getActivePageOffset = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.pageOffset : {};
	}
);

export const hasManualBilling = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.manualBilling : false;
	}
);

export const getIsPaperSizeLetter = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.isPaperSizeLetter : false;
	}
);

export const getUsePLUCode = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.usePLUCode : true;
	}
);

export const getUseUSMetrics = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.useUSMetrics : true;
	}
);

export const getLabelTitleOrder = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined ? activeSubscription.labelTitleOrder : 0;
	}
);

export const getIsEnglish = createSelector(
	getActiveSubscription,
	(activeSubscription) => {
		return activeSubscription !== undefined && activeSubscription.language !== "German"? true : false;
	}
);




/** WEBPACK FOOTER **
 ** ./src/modules/customer/selectors.js
 **/